// @flow

import TextInput from './TextInput';
import NumberInput from './NumberInput';
import Switch from './Switch';
import PasswordInput from './PasswordInput';
import EmailInput from './EmailInput';
import DateInput from './DateInput';
import TimeInput from './TimeInput';
import FieldWrapper from './FieldWrapper';
import FieldWrapperRNE from './FieldWrapperRNE';
import BaseSelect from './BaseSelect';
import ExpandedSelect from './ExpandedSelect';

export {
    TextInput, NumberInput, Switch, PasswordInput, EmailInput, DateInput, TimeInput,
    FieldWrapper, FieldWrapperRNE, BaseSelect, ExpandedSelect,
};

export const RNE_DEFAULT_FIELDS = {
    text: TextInput,
    number: NumberInput,
    password: PasswordInput,
    boolean: Switch,
    email: EmailInput,
    date: DateInput,
    time: TimeInput,
    choice: BaseSelect,
    radio: ExpandedSelect,
};

export const RNE_FALLBACK_FIELD_TYPE = 'text';
